<template>
    <div>
        <div class="developer" v-if="this.$store.getters.developer">
            <b>Entwickler Ausgabe:</b>
            <pre v-html="this.$store.getters.person"></pre>
        </div>
        <h1>{{ transl["STR_DASHBOARD"] }}</h1>

        <div class="charts">

            <div class="chart">
                <div class="title">{{ transl["STR_PROBES_DAY"] }}</div>
                <div class="chart2">
                    <span style="display: none;">{{ test }}</span>
                <apexchart v-if="series.length > 0" width="100%" height="100%" type="bar" :options="options" :series="series"></apexchart>
                </div>
            </div>

            <div class="chart">
                <div class="title">{{ transl["STR_PROBES_DIST"] }}</div>
                <div class="chart2">
                <apexchart v-if="this.series2.length > 0" width="100%" height="100%" type="pie" :options="optionpie" :series="series2"></apexchart>
                </div>
            </div>            


        </div>

    </div>
</template>
<script>
export default({
    props: [ 'transl' ],
    computed: {
       async test() {
           return new Promise((resolve, reject) => {
                var v = [];
                this.series = [];
                this.series2 = [];
                this.$store.dispatch("LoadGraphData").then(() => {
                    this.$store.getters.metrics.forEach((i) => {
                        v.push(i.value);
                        this.options.xaxis.categories.push(i.date);
                    })

                    if(this.$store.getters.getApoStats.probes_total) {
                        this.series2.push(this.$store.getters.getApoStats.total_positive)
                        this.series2.push(this.$store.getters.getApoStats.total_invalids)
                        this.series2.push(this.$store.getters.getApoStats.probes_total)
                    }


                    this.series.push({
                        name: "Proben",
                        data: v,
                    })
                })
           })
       }
    },

    data() {
        return {
            series2: [],
            optionpie: {
                labels: ['positiv', 'ungültig', 'Total'],
                legend: {
                    show: false,
                },                
                fill: {
                    colors: ['#ff4800', '#575a5d', '#323334']
                },
            },
            options: {
                legend: {
                    show: false,
                },
                stroke: {
                    width: 0,
                    curve: 'smooth',
                },
                chart: {               
                toolbar: {
                    show: false,
                },                    
                    id: 'chart0'
                },
                plotOptions: {
                bar: {
                    borderRadius: 1,
                    horizontal: false,
                    dataLabels: {
                    position: 'bottom'
                    }                    
                }
                },                
                fill: {
                colors: ['#323334']
                },               
                xaxis:{
                    categories: []
                }
            },
            series: [],           

        }
    }
})
</script>
